module.exports = __webpack_public_path__ + "static/media/waterMarkIcon.7f6b2385.svg";